// @ helpers
const { APIGet, base64ToBlob } = require('utilities/APIRequestHelper');
const { download } = require('utilities/fileDownloadHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { getLanguage } = require('core/i18n').i18n;
const BrowserUtils = require('utilities/browserUtils');
const { formatText } = require('core/i18n').i18n;

// @ constants
const { DOCUMENT_TYPES: { HOME_ZC } } = require('../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_REQUEST,
    INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_SUCCESS,
    INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_FAILURE,
    INSURANCE_REQUEST_GET_DOCUMENT_ZIP_REQUEST,
    INSURANCE_REQUEST_GET_DOCUMENT_ZIP_SUCCESS,
    INSURANCE_REQUEST_GET_DOCUMENT_ZIP_FAILURE,
} = require('../insuranceConstants/actionTypes');

const { wizardSimulationName: { INSURANCE_SUMMARY_RELATED, INSURANCE_SUMMARY_RNC } } = require('../insuranceConstants/insuranceRequestHome');

const getDocumentZipRequest = () => ({
    type: INSURANCE_REQUEST_GET_DOCUMENT_ZIP_REQUEST,
});

const getDocumentZipSuccess = (zipData, zipWizardName) => ({
    type: INSURANCE_REQUEST_GET_DOCUMENT_ZIP_SUCCESS,
    data: {
        zipData,
        zipWizardName
    }
});

const getDocumentZipFailure = (error) => ({
    type: INSURANCE_REQUEST_GET_DOCUMENT_ZIP_FAILURE,
    data: {
        error,
    }
});

const getDocumentsSummaryRequest = () => ({
    type: INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_REQUEST
});

const getDocumentsSummarySuccess = (b64toBlobResponse, wizard) => ({
    type: INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_SUCCESS,
    data: {
        b64toBlobResponse,
        wizard
    }
});

const getDocumentsSummaryFailure = error => ({
    type: INSURANCE_REQUEST_GET_DOCUMENTS_SUMMARY_FAILURE,
    data: { error }
});

const getDocumentsZip = (wizard) => (dispatch, getState) => {
    let currentState = getState().insuranceRequestState.get('data');
    const isClientWithoutAccounts = wizard === INSURANCE_SUMMARY_RNC;
    if (wizard === INSURANCE_SUMMARY_RELATED) {
        currentState = getState().insuranceRequestRelatedState.get('data');
    } else if (isClientWithoutAccounts) {
        currentState = getState().insuranceRequestRelatedRNCState.get('data');

    }
    const legalDocuments = getState().insuranceRequestLegalDocuments;
    const zipWizardName = `${wizard}Zip`;
    const isFetchingZip = legalDocuments.get('isFetchingZip');
    const documentsName = formatText('insuranceRequestHome-precontractualDocuments');
    const docNamePdf = `${documentsName}.zip`;

    if (currentState.get('id')) {
        if (!isFetchingZip) {
            dispatch(getDocumentZipRequest());
            const requestData = {
                query: {
                    productType: HOME_ZC,
                    language: getLanguage().toUpperCase(),
                    isClientWithoutAccounts,
                }
            };
            return APIGet(
                dispatch,
                apiURLBuilder.getURL('insuranceRequestDocumentCompress', { id: currentState.get('id') }),
                requestData
            )
                .then(response => {
                    const { base64, contentType } = response.data;
                    const base64string = `data:${contentType};base64,${base64}`;
                    const b64toBlobResponse = base64ToBlob(base64string);
                    download(b64toBlobResponse, docNamePdf, contentType);
                    dispatch(getDocumentZipSuccess(b64toBlobResponse, zipWizardName));
                })
                .catch(response => {
                    if (!!response.error) {
                        dispatch(getDocumentZipFailure());
                    } else {
                        throw response;
                    }
                });
        }
    }
};

const getDocumentsSummary = (wizard) => (dispatch, getState) => {
    let currentState = getState().insuranceRequestState.get('data');
    const isClientWithoutAccounts = wizard === INSURANCE_SUMMARY_RNC;
    if (wizard === INSURANCE_SUMMARY_RELATED) {
        currentState = getState().insuranceRequestRelatedState.get('data');
    } else if (isClientWithoutAccounts) {
        currentState = getState().insuranceRequestRelatedRNCState.get('data');
    }
    if (currentState.get('id')) {
        dispatch(getDocumentsSummaryRequest());
        const requestData = {
            query: {
                productType: HOME_ZC,
                language: getLanguage().toUpperCase(),
                isClientWithoutAccounts
            }
        };

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestDocumentMerge', { id: currentState.get('id') }),
            requestData
        )
            .then(response => {
                const { base64, contentType } = response.data;
                const base64string = `data:${contentType};base64,${base64}`;
                const base64Document = {
                    base64string,
                    base64,
                    contentType,
                }
                dispatch(getDocumentsSummarySuccess(base64Document, wizard));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(getDocumentsSummaryFailure());
                } else {
                    throw response;
                }
            });
    }
}

const onPrintDocument = (wizard) => (dispatch, getState) => {
    const legalDocuments = getState().insuranceRequestLegalDocuments;
    const sumary = legalDocuments.getIn([wizard, 'base64']);
    const binaryImg = atob(sumary);
    const length = binaryImg.length;
    const arrayBuffer = new ArrayBuffer(length);
    const uintArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < length; i++) {
        uintArray[i] = binaryImg.charCodeAt(i);
    }
    const currentBlob = new Blob([uintArray], { type: 'application/pdf' });

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(currentBlob);
    } else {
        const blobURL = window.URL.createObjectURL(currentBlob);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

module.exports = {
    getDocumentsSummary,
    onPrintDocument,
    getDocumentsZip,
};
